import React, { forwardRef } from 'react';
import type { LinkProps } from 'next/link';
import { Link } from './link';

type NavLinkProps = Partial<Omit<LinkProps, 'as'>> &
  Omit<React.ComponentPropsWithoutRef<'a'>, 'color'> &
  Omit<React.ComponentPropsWithoutRef<'button'>, 'color'> & {
    headless?: boolean;
    color?: 'light' | 'default';
    size?: 'tiny' | 'small' | 'base' | 'large' | 'inherit';
  };

const baseNavItemClasses = `
  border-b-2 border-transparent transition-[border-bottom] duration-250
  hover:border-[var(--color-secondary)] focus-visible:border-[var(--color-secondary)] focus-visible:outline-none
  whitespace-nowrap
  !font-normal
  !text-inherit
`;

export const NavLink = forwardRef<HTMLAnchorElement | HTMLButtonElement, NavLinkProps>((props, ref) => {
  const { className, ...rest } = props;

  return <Link ref={ref} underline={false} className={`${baseNavItemClasses} ${className || ''}`} {...rest} />;
});
